import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Button, Loader, Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { SOFT_SIGNALS, SoftSignalPayload } from 'models/Lead';
import TextAreaField from 'components/TextAreaField';
import validations from 'validations';

import './DealUnsureSignalModal.styles.scss';

type DealUnsureSignalModalProps = {
  className?: string;
  onSubmit: (values: SoftSignalPayload, isSkipPressed?: boolean) => void;
} & ModalProps;

const DealUnsureSignalModal: React.ForwardRefRenderFunction<
  ModalRef,
  DealUnsureSignalModalProps
> = (props, ref) => {
  const { className, onSubmit, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('deal-unsure-signal-modal', className);

  const { t } = useTranslation();

  return (
    <Modal ref={modalRef} className={classes} title={t('tellUsMore')} {...rest}>
      <Form
        onSubmit={(values: SoftSignalPayload) =>
          onSubmit({ ...values, softSignal: SOFT_SIGNALS.UNSURE }, false)
        }
        render={({ submitting, invalid, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            {submitting && <Loader />}

            <Field
              name="message"
              component={TextAreaField}
              label={t('haveSpecificQuestion')}
              rows={4}
              required
              validate={validations.required()}
            />

            <div className="actions">
              <Button variant="link" onClick={modal?.close}>
                {t('cancel')}
              </Button>

              <Button type="submit" disabled={submitting || invalid}>
                {t('send')}
              </Button>
            </div>
          </form>
        )}
      />
    </Modal>
  );
};

export default forwardRef(DealUnsureSignalModal);
